import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
// import store from '@/store'
// import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.28.242:8081', // 丁api的base_url
   baseURL: 'https://api.qzkjg.org.cn', // api的base_url
   // baseURL: 'http://192.168.28.137:8081', // 宗api的base_url
   // baseURL: 'http://192.168.28.91:50211', // 郑api的base_ur
   // baseURL: 'http://192.168.100.161:10611', // api的base_url
  timeout: 5000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    if(Cookies.get('userInfo')){
      if(JSON.parse(Cookies.get('userInfo')).token){
        config.headers['token'] = JSON.parse(Cookies.get('userInfo')).token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
      }
    }
//   }
  return config

}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
   console.log()
  /**
  * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
  * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
  */
   const res = response.data;
     if (res.code == 403) {

       if(window.location.pathname&&window.location.pathname!='/'){
         Cookies.remove('userAllInfo')
         Cookies.remove('userInfo')
         Message({
          message: res.msg,
           type: 'error',
          duration: 5 * 1000
         });
         router.push({name:'Login'})
       }else if(window.location.pathname=='/'){
        Cookies.remove('userAllInfo')
        Cookies.remove('userInfo')
        Message({
         message: res.msg,
          type: 'error',
         duration: 5 * 1000
        });
        router.push({name:'Index'})
       }else{
         Cookies.remove('userAllInfo')
         Cookies.remove('userInfo')
         Message({
          message: res.msg,
           type: 'error',
          duration: 5 * 1000
         });
         router.push({name:'Index'})
       }

        // return Promise.reject('error');
        return response;
      } else if(res.code==0){
        return response;
      }else{
        Message({
         message: res.msg,
          type: 'error',
         duration: 5 * 1000
        });
        return response;
        // return Promise.reject('error');
     }
  },
  error => {
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request1.js